<template>
  <div v-if="isOpen" class="fixed inset-0 flex items-center justify-center" style="background-color: rgba(0, 0, 0, 0.75); z-index: 9999999;" @click="$emit('close')">
    <div 
      class="max-w-md w-11/12 text-center relative" 
      style="background-color: rgb(28, 28, 28); border: 1px solid rgb(64, 64, 64);"
      @click.stop
    >
      <!-- Close button -->
      <button
        @click.stop="$emit('close')"
        class="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-t-secondary hover:text-t-primary hover:bg-interactive-interactiveBgHover transition-colors text-2xl leading-none"
        style="background-color: transparent;"
      >
        ×
      </button>

      <div class="p-8 pt-12">
        <h2 class="text-t-primary text-2xl font-semibold mb-3">Connect Wallet</h2>
        
        <p class="text-t-secondary text-sm mb-8">Choose your wallet to connect</p>
        
        <div class="space-y-3">
          <!-- Bybit Button -->
          <button
            @click.stop="$emit('select-bybit')"
            class="w-full py-3 px-4 bg-primary-gradient text-t-dark hover:bg-interactive-primaryActive active:bg-interactive-primaryActive transition-all flex items-center justify-center gap-2 text-subtitle1 font-normal"
            style="border-radius: 0;"
          >
            <img src="/bybit-logo-real.svg" alt="Bybit" class="h-5 object-contain" />
            Connect Bybit
          </button>
          
          <!-- WalletConnect Button -->
          <button
            @click.stop="$emit('select-walletconnect')"
            class="w-full py-3 px-4 bg-primary-gradient text-t-dark hover:bg-interactive-primaryActive active:bg-interactive-primaryActive transition-all text-subtitle1 font-normal"
            style="border-radius: 0;"
          >
            Other Wallets (Wallet Connect)
          </button>
          
          <button
            @click.stop="$emit('close')"
            class="w-full py-3 px-4 bg-transparent text-t-secondary border border-border-line hover:bg-interactive-interactiveBgHover hover:text-t-primary transition-all text-subtitle1 font-normal cursor-pointer"
            style="border-radius: 0;"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WalletChoiceModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  }
}
</script>
